<ion-card>
  <ion-item *ngIf="!isRecheck" class="close-btn" lines="none">
    <ion-button slot="end" fill="clear" size="small" color="dark" (click)="onClose()">
      <ion-icon name="close" slot="end"></ion-icon>
    </ion-button>
  </ion-item>
  <ion-card-header>
    <ion-card-title>Has de estar de acuerdo con la Política de Privacidad y los Términos de Servicio</ion-card-title>
  </ion-card-header>

  <ion-card-content>
    <form [formGroup]="accountForm">
      <ion-item lines="none">
        <ion-checkbox formControlName="generalTerms" checked="false" labelPlacement="end">
          He leído y acepto la <a [href]="env.policyUrl" target="_blank">política de privacidad</a> y los
          <a [href]="env.tosUrl" target="_blank">términos de servicio</a>
          <ion-text color="danger">*</ion-text>
        </ion-checkbox>
      </ion-item>
      <br />
      <ng-container *ngIf="isRecheck; else elseTemplate">
        <ion-button expand="block" (click)="onClose({ continue: true })" [disabled]="accountForm.invalid"
          >Estoy de acuerdo</ion-button
        >
        <ion-button expand="block" fill="outline" (click)="onClose()">Desconectarme y seguir navegando</ion-button>
      </ng-container>
      <ng-template #elseTemplate>
        <ion-button expand="block" (click)="onClose({ continue: true })" [disabled]="accountForm.invalid"
          >Continuar</ion-button
        >
      </ng-template>
    </form>
  </ion-card-content>
</ion-card>
